import BooleanIndicator from "./BooleanIndicator";

export default BooleanIndicator